<template>
  <div :class="{'input-group': !hideButton, 'input-block': !hideButton}">
    <input
      type="text"
      class="form-control"
      :id="inputId"
      :placeholder="placeholderText"
      v-model="searchQuery"
      @input="queryChanged"
    >
    <transition name="fade">
      <alert
        type="warning"
        class="action-alert text-center search-warning"
        v-if="byteLimitReached"
      >
        {{ byteLimitMessage }}
      </alert>
    </transition>
    <span :class="{'input-group-btn': !hideButton}" v-if="!hideButton">
      <slot name="button">
        <button
          class="btn btn-primary"
          :disabled="!searchQuery"
          @click="queryChanged">
          <i class="fa fa-search"/> <span class="hidden-xs">{{ buttonText }}</span>
        </button>
      </slot>
    </span>
  </div>
</template>

<script>
import { debouncer } from '@/util/debouncer'
import { isQueryTooLong, ALGOLIA_BYTE_LIMIT } from '@/util/browse'

export default {
  name: 'SearchInput',
  props: {
    initialQuery: {
      type: String,
      default: ''
    },
    placeholderText: {
      type: String,
      default: 'Keyword search'
    },
    buttonText: {
      type: String,
      default: ''
    },
    debounceDurationMs: {
      type: Number,
      default: 200
    },
    hideButton: {
      type: Boolean,
      default: false
    },
    inputId: {
      type: String,
      default: 'search-input'
    },
    byteLimitEnforced: {
      type: Boolean,
      default: false
    },
    byteLimit: {
      type: Number,
      default: ALGOLIA_BYTE_LIMIT
    },
    byteLimitMessage: {
      type: String,
      default: 'Please use a shorter search query.'
    }
  },
  data() {
    return {
      searchQuery: '',
      queryChanged: debouncer(() => {
        this.$emit('query:changed', this.searchQuery)
      }, this.debounceDurationMs)
    }
  },
  computed: {
    byteLimitReached() {
      return this.byteLimitEnforced && isQueryTooLong(this.searchQuery, this.byteLimit)
    }
  },
  watch: {
    initialQuery(val) {
      // if the keyword was cleared outside of this component, we should also clear the text in the search input
      if (this.searchQuery && !val) {
        this.searchQuery = ''
      }
    }
  },
  created() {
    if (this.initialQuery) {
      this.searchQuery = this.initialQuery
    }
  }
}
</script>

<style scoped>
   .search-warning {
    margin-top: 5px;
    color: #524633
   }
</style>